import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  UpdateStatus,
} from "../../../../../../../features/admin/website/contact_us/get_in_touch/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const getInTouch = useSelector((state) => state?.website?.get_in_touch);

  console.log(getInTouch, "successSpeaks");

  const [name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [name]);

  const fetch = async (page = getInTouch?.current_page) => {
    await dispatch(
      GetAll({
        name: name,
        page: page,
        per_page: getInTouch?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(UpdateStatus(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    getInTouch,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
  };
};
